import { atom } from "jotai";
import { userConfig } from "./type";

const initialState: userConfig = {
  visualConfig: {
    loading: true,
  },
};

export const userConfigAtom = atom(initialState);
